module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "button-signup button-primary btn-block align-items-stretch justify-content-center d-flex"
  }, [_c('div', [_vm._v(_vm._s(_vm.site.name) + " Issue Alert Sign Up")]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrapper align-self-center"
  }, [_c('i', {
    staticClass: "icon icon-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a79c056"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/sidebar/SidebarSignUpButtonComponent.vue
// module id = 1419
// module chunks = 1